import { render, staticRenderFns } from "./ConsultResponseV3Detail.vue?vue&type=template&id=033774a0&scoped=true&"
import script from "./ConsultResponseV3Detail.vue?vue&type=script&lang=ts&"
export * from "./ConsultResponseV3Detail.vue?vue&type=script&lang=ts&"
import style0 from "./ConsultResponseV3Detail.vue?vue&type=style&index=0&id=033774a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033774a0",
  null
  
)

export default component.exports